import type { FertilityTreatmentsState } from "./FertilityTreatmentsContext";

type ScreenName =
  | "FertilityTreatmentsTypes"
  | "IUITreatments"
  | "IVFTreatments"
  | "MedsOnlyTreatments"
  | "OITreatments"
  | "TimedIntercourseTreatments"
  | "FETTreatments"
  | "EggFreezing"
  | "EmbryoFreezing"
  | "OtherTreatments"
  | "UnknownTreatments"
  | "FertilityTreatmentsComplete";

export function buildTreatmentNavigationStack(
  selectedTypes: string[],
): string[] {
  const stack: string[] = [];
  if (selectedTypes.length > 0) {
    const map: Record<string, string> = {
      ivf_icsi: "IVFTreatments",
      iui: "IUITreatments",
      oi: "OITreatments",
      medicated_cycle: "OITreatments",
      meds_only: "MedsOnlyTreatments",
      timed_intercourse: "TimedIntercourseTreatments",
      other: "OtherTreatments",
      unknown: "UnknownTreatments",
      fet: "FETTreatments",
      egg_freezing: "EggFreezing",
      embryo_freezing: "EmbryoFreezing",
    };
    selectedTypes.forEach((t) => {
      const screen = map[t];
      if (screen) stack.push(screen);
    });
  }
  stack.push("FertilityTreatmentsComplete");
  return stack;
}

export function getNextTreatmentScreen(
  state: FertilityTreatmentsState,
): ScreenName {
  const { navigationStack = [], currentNavigationIndex = 0 } = state;
  if (currentNavigationIndex >= navigationStack.length) {
    return "FertilityTreatmentsComplete";
  }
  return navigationStack[currentNavigationIndex] as ScreenName;
}
